import { ContentCards} from "../../components/Reusable/resuable";
import { SubServicesdata } from "../../services/data";
import { DataType } from "../../models/models";
import { BackButton } from "../../components/Reusable/resuable";
import { Helmet } from "react-helmet-async";
const typedData:DataType=SubServicesdata;
export default function MainService() {
    var type=localStorage.getItem('servicetype');
    var cranes=typedData[parseInt(type||'0')];
    return <div className="mainService">
        <BackButton name="Back"/>
        {
            cranes.map((item, i) => <ContentCards key={i} {...item}/>)
        }
    </div>
}